/**
 * Utility functions for Christmas theme
 */

/**
 * Check if the current date is within the Christmas theme period
 * @returns true if current date is between November 15th and December 26th (inclusive)
 */
export const isChristmasPeriod = (): boolean => {
  const now = new Date();
  const month = now.getMonth(); // 0-based: 0 = January, 11 = December
  const day = now.getDate();

  // November (month 10) from 15th onwards
  if (month === 10 && day >= 15) {
    return true;
  }

  // December (month 11) up to 26th
  if (month === 11 && day <= 26) {
    return true;
  }

  return false;
};
